/** Unix `exp` from a JWT access token, or null if it cannot be read. */
export function accessTokenExpiresAtSec(token: string | null | undefined): number | null {
  if (!token) return null;
  const parts = token.split('.');
  if (parts.length < 2) return null;
  try {
    const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4);
    const payload = JSON.parse(atob(padded)) as { exp?: unknown };
    const exp = Number(payload?.exp);
    return Number.isFinite(exp) ? exp : null;
  } catch {
    return null;
  }
}

/** True when the token is missing, unreadable, or past `exp` (optional clock for tests). */
export function accessTokenIsExpired(
  token: string | null | undefined,
  nowSec: number = Date.now() / 1000
): boolean {
  const exp = accessTokenExpiresAtSec(token);
  if (exp == null) return true;
  return nowSec >= exp;
}
